var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2060_781)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49799 5.88961V5.87207C6.4944 5.87795 6.48944 5.88383 6.48633 5.88961H6.49799Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.5V12.5H12V0.5H0ZM3.73245 10.4693H1.95207V5.11291H3.73245V10.4693ZM2.84226 4.38183H2.8305C2.23327 4.38183 1.84615 3.97037 1.84615 3.45609C1.84615 2.93051 2.24458 2.53072 2.85392 2.53072C3.46338 2.53072 3.83792 2.93051 3.84957 3.45609C3.84957 3.97037 3.46338 4.38183 2.84226 4.38183ZM10.1538 10.4693H8.37299V7.6036C8.37299 6.88384 8.11569 6.39253 7.47115 6.39253C6.97891 6.39253 6.6864 6.72333 6.55754 7.04377C6.5107 7.15823 6.49846 7.31735 6.49846 7.47785V10.4693H4.71727C4.71727 10.4693 4.74113 5.61543 4.71727 5.11293H6.49846V5.87194C6.73511 5.5078 7.15743 4.98718 8.10346 4.98718C9.27542 4.98718 10.1538 5.75254 10.1538 7.39768V10.4693Z",
    fill: "#2667B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2060_781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIconBlue);
export default __webpack_public_path__ + "static/media/linkedin_icon_blue.e8835fa16815f15d52f52ce4d9096722.svg";
export { ForwardRef as ReactComponent };